import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_element_loading = _resolveComponent("vue-element-loading")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_vue_element_loading, {
      active: _ctx.isLoading,
      size: String(_ctx.size),
      spinner: "spinner",
      color: "#6D99C6",
      "is-full-screen": "",
      "background-color": "rgba(255, 255, 255, 0.5)"
    }, null, 8, ["active", "size"])
  ]))
}